import * as API_CONSTANT from "../constants";

export const getRemarkThruRefid = (uid, refid) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/remark/get/refid`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({ uid, refid }),
  }).then((res) => res.json());

export const createRemark = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/remark/create`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const updateRemark = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/remark/update`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const deleteRemark = (remid) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/remark/delete`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({ remid }),
  }).then((res) => res.json());
